// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VaZ6REMWz0jzxtq3SsFP{border-radius:12px 12px 0 0}.MuB43GnINdoDexYY6Cpz{justify-content:center;align-items:center;gap:8px;display:flex}.MuB43GnINdoDexYY6Cpz .Ec1H4fEzTwohJffkpcWR{border:1px solid var(--action-outlined-tertiary-border);background:var(--background-primary-inverted-primary);border-radius:4px;width:-webkit-max-content;width:max-content;padding:2px}.vfUz5nNRbZETIeyqFNUN{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `VaZ6REMWz0jzxtq3SsFP`,
	"customTitleWrapper": `MuB43GnINdoDexYY6Cpz`,
	"icon": `Ec1H4fEzTwohJffkpcWR`,
	"alert": `vfUz5nNRbZETIeyqFNUN`
};
export default ___CSS_LOADER_EXPORT___;
